import {Component, ElementRef, forwardRef, HostBinding, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractNgModelComponent} from '../../../core/ng-model.component';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {File} from 'app/entities/file.entity';
import {HelperService} from '../../../services/helper.service';
import {AppService} from '../../../services/app.service';
import {plainToInstance} from 'class-transformer';
import {Document} from '../../../entities/document.entity';
import {FileGroupTypes} from '../../../entities/enums';
import {File as ChatFile} from '../../../../../chat-sdk/src/entities/file';

@Component({
  selector: 'app-file-input',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileComponent),
      multi: true
    }
  ]
})
export class FileComponent extends AbstractNgModelComponent<any> implements OnInit {
  @ViewChild('fileInput', {static: false}) fileInput: any;

  @Input() labelText?: string;
  @Input() previewType: 'square' | 'line' = 'square';

  @Input() state: 'success' | 'error';
  @Input() showErrorElement = true;
  @Input() clearInput: boolean;
  @Input() errorText: string;

  @Input() errorTextPosition: 'left' | 'right' | 'center' = 'left';
  @Input() requiredLabel = false;

  @Input() multiple: boolean = false;
  @Input() maxFiles: number = 1;
  @Input() acceptsType: FileGroupTypes[] = ['video', 'image', 'doc'];
  @Input() accepts: string[] = HelperService.fileExt();
  @Input() maxSize: number = 5; // MB
  @Input() labelSize = 'regular';

  @Input() profileFix = true;
  @Input() scrollMode = false;

  HelperService = HelperService;

  modalOpen = false;

  files: File[] = [];

  appService: AppService;

  constructor(
    appService: AppService,
    injector: Injector
  ) {
    super(injector);

    this.appService = appService;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.filesInit();
      this.onChange();
    }, 200);
  }

  filesInit() {
    this.setDefaultValues();

    if (Array.isArray(this.value)) {

      if (!(this.value.every(val => val instanceof File || val instanceof ChatFile))) {
        this.value = plainToInstance(File, this.value);
      }

      this.files = this.value;
    }
  }

  writeValue(value): void {
    super.writeValue(value);
    this.filesInit();
  }

  setDefaultValues() {

    if (!this.acceptsType) {
      this.acceptsType = ['video', 'image', 'doc'];
    }

    if (!this.accepts) {
      this.accepts = HelperService.fileExt();
    }

    if (!this.maxFiles) {
      this.maxFiles = 10;
    }

    if (!this.maxSize) {
      this.maxSize = 5;
    }

    if (!this.files) {
      this.files = [];
    }
  }

  onChange() {

    this.checkIfDisabled();


    const oldFiles = this.files?.filter((item) => item.nativeFile === null)?.map((item) => item.id);
    const files = this.files?.filter((item) => item.nativeFile !== null)?.map((item) => item.nativeFile);

    if (this.profileFix) {
      this.value = {};
      if (oldFiles?.length) {
        this.value.oldFiles = oldFiles;
      }

      if (files?.length) {
        this.value.files = files;
      }

      if (oldFiles?.length === 0 && files?.length === 0) {
        this.value = null;
      }
    } else {
      this.value = [...oldFiles, ...files];
    }

    this.changeModelEvent.emit(this.value);
    this.onTouchModel();
  }

  checkIfDisabled() {

    this.disabled = this.files?.length >= this.maxFiles;
  }

  @HostBinding('class')
  get classes() {
    return {
      [`input-state-${this.state}`]: this.state,
    };
  }

  fileUpload($event: any) {

    this.modalOpen = false;

    if (!this.disabled) {
      let files = $event.target.files;

      if (files.length > 0) {
        files = [...files];

        const fileToUpload = files.filter((file) => this.validateSize(file) && this.validateExt(file));

        if (fileToUpload.length) {
          if (this.files?.length + fileToUpload.length > this.maxFiles) {
            this.appService.showToast(`Можно залить только ${this.maxFiles} файлов`, 'danger');
          }

          this.addToFiles(fileToUpload.slice(0, this.maxFiles - this.files?.length));
        }

      }
    }

  }

  addToFiles(files) {

    // @todo chat redo to File.fromWebApiFIle
    files.forEach((file) => {
      const fileClass = plainToInstance(File, {
        id: 0,
        url: URL.createObjectURL(file),
        extension: HelperService.getNativeFileExt(file),
        title: file.name
      });
      fileClass.nativeFile = file;

      this.files.push(fileClass);
    });

    this.onChange();
  }

  validateSize(file: any) {
    const sizeMb = file.size / 1024 / 1024;

    if (parseFloat(sizeMb as any) > parseFloat(this.maxSize as any)) {
      this.appService.showToast(`Размер файла не должен превышать ${this.maxSize} Мб`, 'danger');

      return false;
    }

    return true;
  }

  validateExt(file: any) {
    const ext = HelperService.getNativeFileExt(file);

    if (this.accepts.includes(ext)) {
      return true;
    } else {
      this.appService.showToast(`Принимаются только ${this.accepts.join(', ')}`, 'danger');
      return false;
    }
  }

  deleteFile(index: any) {
    this.files.splice(index, 1);

    this.onChange();
  }

  openModal() {
    this.modalOpen = true;
  }
}
